/* ============================================================
   lev-store-locator
   Il server ha già stampato tutte le schede. Qui si filtra, si tiene
   aggiornato lo stato di apertura e si disegna la mappa. La lista non
   viene mai ridisegnata: il contenuto indicizzabile non dipende dal JS.
   ============================================================ */
(function () {
  'use strict';

  function traccia(evento, dati) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: evento };
    for (var k in dati) {
      if (Object.prototype.hasOwnProperty.call(dati, k)) payload[k] = dati[k];
    }
    window.dataLayer.push(payload);
  }

  function minuti(hhmm) {
    var p = String(hhmm || '').split(':');
    return (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0);
  }

  function hhmm(v) {
    return String(Math.floor(v / 60)).padStart(2, '0') + ':' + String(v % 60).padStart(2, '0');
  }

  function normalizza(t) {
    return String(t || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/['\u2019]/g, '');
  }

  /* Google Maps si carica una volta per pagina, non una per sezione. */
  var mapsPromise = null;

  function caricaMaps(key) {
    if (mapsPromise) return mapsPromise;
    mapsPromise = new Promise(function (resolve, reject) {
      if (window.google && window.google.maps) return resolve(window.google.maps);
      var cb = 'levMapsReady';
      window[cb] = function () { resolve(window.google.maps); };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?loading=async&callback=' + cb + '&key=' + encodeURIComponent(key);
      s.async = true;
      s.onerror = function () { reject(new Error('Google Maps non raggiungibile')); };
      document.head.appendChild(s);
    });
    return mapsPromise;
  }

  function init(root) {
    if (!root || root.dataset.levPronto === '1') return;
    root.dataset.levPronto = '1';

    var q = root.querySelector('[data-lev-q]');
    var field = root.querySelector('[data-lev-field]');
    var clear = root.querySelector('[data-lev-clear]');
    var chips = [].slice.call(root.querySelectorAll('[data-lev-regione]'));
    var list = root.querySelector('[data-lev-list]');
    var vuoto = root.querySelector('[data-lev-empty]');
    var reset = root.querySelector('[data-lev-reset]');
    var contatore = root.querySelector('[data-lev-count]');
    var mapBox = root.querySelector('[data-lev-map]');
    var modal = root.querySelector('[data-lev-modal]');
    var modalBody = root.querySelector('[data-lev-modal-body]');
    var modalTitle = root.querySelector('[data-lev-modal-title]');
    var modalSub = root.querySelector('[data-lev-modal-sub]');
    var modalClose = root.querySelector('[data-lev-modal-close]');

    if (!list) return;

    var cards = [].slice.call(list.querySelectorAll('[data-lev-card]'));
    if (!cards.length) return;

    var apre = minuti(root.dataset.apre || '09:00');
    var chiude = minuti(root.dataset.chiude || '20:00');
    var stato = { q: '', regione: '' };

    var dati = cards.map(function (card) {
      var lat = parseFloat(card.dataset.levLat);
      var lon = parseFloat(card.dataset.levLon);
      return {
        card: card,
        nome: card.dataset.levNome || '',
        comune: card.dataset.levComune || '',
        regione: card.dataset.levRegione || '',
        cerca: normalizza(card.dataset.levCerca),
        lat: isNaN(lat) ? null : lat,
        lon: isNaN(lon) ? null : lon,
        details: card.querySelector('[data-lev-details]'),
        marker: null
      };
    });

    /* ---------- stato di apertura ---------- */
    function statoApertura() {
      var d = new Date();
      var m = d.getHours() * 60 + d.getMinutes();
      if (m >= apre && m < chiude) {
        var restano = chiude - m;
        return {
          aperto: true,
          principale: 'Aperto ora',
          soft: restano <= 60 ? '· chiude tra ' + restano + ' min' : '· chiude alle ' + hhmm(chiude)
        };
      }
      return {
        aperto: false,
        principale: 'Chiuso',
        soft: m < apre ? '· apre alle ' + hhmm(apre) : '· apre domani alle ' + hhmm(apre)
      };
    }

    function aggiornaStato() {
      var st = statoApertura();
      cards.forEach(function (card) {
        var box = card.querySelector('[data-lev-status]');
        if (!box) return;
        box.classList.toggle('lev-store__is-open', st.aperto);
        box.classList.toggle('lev-store__is-closed', !st.aperto);
        var main = box.querySelector('[data-lev-status-main]');
        var soft = box.querySelector('[data-lev-status-soft]');
        if (main) main.textContent = st.principale;
        if (soft) soft.textContent = st.soft;
      });
    }

    /* ---------- filtro ---------- */
    function applica() {
      var visibili = [];
      dati.forEach(function (s) {
        var ok =
          (!stato.q || s.cerca.indexOf(stato.q) !== -1) &&
          (!stato.regione || s.regione === stato.regione);
        s.card.hidden = !ok;
        if (s.marker) s.marker.setVisible(ok);
        if (ok) visibili.push(s);
      });

      if (contatore) contatore.textContent = visibili.length + ' store';
      if (vuoto) vuoto.hidden = visibili.length > 0;
      inquadra(visibili);
      return visibili;
    }

    /* ---------- mappa ---------- */
    var mappa = null;
    var maps = null;

    function inquadra(visibili) {
      if (!mappa || !maps) return;
      var punti = visibili.filter(function (s) { return s.lat != null; });
      if (!punti.length) return;
      if (punti.length === 1) {
        mappa.setCenter({ lat: punti[0].lat, lng: punti[0].lon });
        mappa.setZoom(14);
        return;
      }
      var b = new maps.LatLngBounds();
      punti.forEach(function (s) { b.extend({ lat: s.lat, lng: s.lon }); });
      mappa.fitBounds(b, 40);
    }

    function creaMappa(api) {
      maps = api;
      mappa = new maps.Map(mapBox, {
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
        gestureHandling: 'cooperative' // su mobile non ruba lo scroll della pagina
      });

      dati.forEach(function (s) {
        if (s.lat == null) return;
        // ponytail: google.maps.Marker è deprecato ma non richiede mapId né la
        // libreria marker. Si passa ad AdvancedMarkerElement quando serve altro.
        s.marker = new maps.Marker({
          map: mappa,
          position: { lat: s.lat, lng: s.lon },
          title: s.nome,
          visible: !s.card.hidden
        });
        s.marker.addListener('click', function () { vaiA(s.card.id); });
      });

      inquadra(dati.filter(function (s) { return !s.card.hidden; }));
    }

    if (mapBox && root.dataset.levMapsKey) {
      // si carica al primo avvicinamento, non nel critical path
      var avviaMappa = function () {
        caricaMaps(root.dataset.levMapsKey).then(creaMappa).catch(function () {
          // Google non risponde: nascondo il riquadro, la lista funziona comunque
          var wrap = root.querySelector('[data-lev-mapwrap]');
          if (wrap) wrap.hidden = true;
        });
      };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          avviaMappa();
        }, { rootMargin: '300px' });
        io.observe(mapBox);
      } else {
        avviaMappa();
      }
    }

    /* ---------- apertura scheda ---------- */
    function vaiA(id) {
      var s = dati.filter(function (x) { return x.card.id === id; })[0];
      if (!s) return;
      s.card.scrollIntoView({ block: 'center', behavior: 'smooth' });
      apriModale(s);
    }

    /* Il pannello è stampato dal server dentro il <li>: senza JS il <details>
       lo apre come accordion. Con il JS lo spostiamo dentro il <dialog> e lo
       rimettiamo al suo posto alla chiusura, così il contenuto in pagina resta
       uno solo e non va duplicato. */
    var apertoOra = null;

    function rimetti() {
      if (!apertoOra) return;
      apertoOra.details.appendChild(apertoOra.panel);
      apertoOra.details.open = false;
      apertoOra = null;
    }

    function apriModale(s) {
      if (!modal || !modalBody || !s.details) return false;
      if (typeof modal.showModal !== 'function') return false; // niente <dialog>: resta l'accordion
      var panel = s.details.querySelector('.lev-store__panel') ||
        (apertoOra && apertoOra.card === s.card ? apertoOra.panel : null);
      if (!panel) return false;

      rimetti();
      if (modalTitle) modalTitle.textContent = s.nome;
      if (modalSub) modalSub.textContent = s.card.dataset.levSub || '';
      modalBody.appendChild(panel);
      apertoOra = { card: s.card, details: s.details, panel: panel };

      modal.showModal();
      return true;
    }

    if (modalClose) modalClose.addEventListener('click', function () { modal.close(); });

    if (modal) {
      // click sullo sfondo: <dialog> non lo chiude da solo
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.close();
      });
      modal.addEventListener('close', function () {
        rimetti();
        if (history.replaceState) {
          history.replaceState(null, '', location.pathname + location.search);
        }
      });
    }

    // il click su <summary> aprirebbe l'accordion: lo dirottiamo sul modale
    list.addEventListener('click', function (e) {
      var summary = e.target.closest('summary');
      if (!summary || !list.contains(summary)) return;
      var card = summary.closest('[data-lev-card]');
      var s = dati.filter(function (x) { return x.card === card; })[0];
      if (!s) return;

      if (!apriModale(s)) return; // modale non disponibile: lascio aprire il <details>
      e.preventDefault();

      if (history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search + '#' + card.id);
      }
      traccia('store_view', { store_name: card.dataset.levNome, store_city: card.dataset.levComune });

      if (s.marker && mappa) {
        mappa.panTo(s.marker.getPosition());
        if (mappa.getZoom() < 12) mappa.setZoom(12);
      }
    });

    /* ---------- ricerca ---------- */
    var timer = null;
    if (q) {
      q.addEventListener('input', function () {
        stato.q = normalizza(q.value.trim());
        if (field) field.classList.toggle('lev-store__search--has-value', !!q.value);
        var trovati = applica();
        clearTimeout(timer);
        if (stato.q.length >= 2) {
          timer = setTimeout(function () {
            traccia('store_search', { search_term: q.value.trim(), stores_found: trovati.length });
          }, 700);
        }
      });
    }

    if (clear) {
      clear.addEventListener('click', function () {
        q.value = '';
        stato.q = '';
        if (field) field.classList.remove('lev-store__search--has-value');
        q.focus();
        applica();
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        stato.regione = chip.dataset.levRegione;
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', String(c.dataset.levRegione === stato.regione));
        });
        applica();
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        stato.q = '';
        stato.regione = '';
        if (q) q.value = '';
        if (field) field.classList.remove('lev-store__search--has-value');
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', String(c.dataset.levRegione === ''));
        });
        applica();
      });
    }

    /* ---------- azioni: un solo listener delegato ----------
       Sta su root e non su list perché a scheda aperta il pannello è dentro il
       <dialog>, fuori dal <li>: i click non passerebbero più dalla lista. */
    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-lev-card]');
      if (!card && apertoOra) card = apertoOra.card; // pannello spostato nel modale
      if (!card) return;
      var nome = card.dataset.levNome;

      if (e.target.closest('[data-lev-directions]')) traccia('store_directions_click', { store_name: nome });
      else if (e.target.closest('[data-lev-call]')) traccia('store_call_click', { store_name: nome });
      else if (e.target.closest('[data-lev-whatsapp]')) traccia('store_whatsapp_click', { store_name: nome });

      var copia = e.target.closest('[data-lev-copy]');
      if (copia && navigator.clipboard) {
        navigator.clipboard.writeText(copia.dataset.levCopyText || '').then(function () {
          var lbl = copia.querySelector('[data-lev-copy-label]');
          if (!lbl) return;
          var vecchio = lbl.textContent;
          lbl.textContent = 'Copiato';
          setTimeout(function () { lbl.textContent = vecchio; }, 1600);
        });
      }
    });

    // il pulsante Copia esiste solo se il JS c'è
    if (navigator.clipboard) {
      [].slice.call(list.querySelectorAll('[data-lev-copy]')).forEach(function (b) { b.hidden = false; });
    }

    window.addEventListener('hashchange', function () {
      if (location.hash.indexOf('#store-') === 0) vaiA(location.hash.slice(1));
    });

    applica();
    aggiornaStato();
    setInterval(aggiornaStato, 60000);

    if (location.hash.indexOf('#store-') === 0) vaiA(location.hash.slice(1));
  }

  function avvia(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-lev-store-locator]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { avvia(); });
  } else {
    avvia();
  }

  // theme editor
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-lev-store-locator]');
    if (root) delete root.dataset.levPronto;
  });
})();
